module.exports = __webpack_public_path__ + "static/media/portfolio_site_discovery_1.f1cbd7fd.png";